import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 34DD1168-3875-4F77-9C0B-5BCFFB80FBBD
 * name map-marker-minus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-minus.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const MapMarkerMinusIcon = createSvgIcon(<><path d="M9,11.5A2.5,2.5 0 0,0 11.5,9A2.5,2.5 0 0,0 9,6.5A2.5,2.5 0 0,0 6.5,9A2.5,2.5 0 0,0 9,11.5M9,2C12.86,2 16,5.13 16,9C16,14.25 9,22 9,22C9,22 2,14.25 2,9A7,7 0 0,1 9,2M15,17H23V19H15V17Z" /></>, 'MapMarkerMinusIcon');
export default MapMarkerMinusIcon